// extracted by mini-css-extract-plugin
export default {"contentContainer":"routeError_contentContainer__7I-Mn"};